import React, { useState, useImperativeHandle, forwardRef, useRef } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

const CenterIntroTextArea = forwardRef((props, ref) => {
  const { className, placeholder, type, defaultValue, setVal } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [value, setValue] = useState(defaultValue);
  const [changed, setChanged] = useState(false);
  const [changedPlaceholderColor, setChangedPlaceholderColor] = useState(false);
  const [clickCount, setClickCount] = useState(0);
  const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

  const inputRef = useRef();

  useImperativeHandle(ref, () => ({
    setValue: (val) => {
      setValue(val);
      setChanged(true);
    },
    getValue: () => {
      return value;
    },
    plusClickCount: () => {
      setClickCount(clickCount + 1)
    },
    getClickCount: () => {
      return clickCount;
    },
    setDefaultPlaceholder: (val) => {
      setDefaultPlaceholder(val)
      setChangedPlaceholderColor(true);
      inputRef.current.style.borderColor = theme.pointRed;
    },
    reset: (val) => {
      setClickCount(0);
      setDefaultPlaceholder(val)
      inputRef.current.style.borderColor = theme.line;
    }
  }));

  function onChangeInput(e) {
    if (e.target.value.length > 250) {
      // alert를 동기 호출하면 controlled input 값 복원이 방해받아 초과 글자가 남음 - 다음 틱으로 미뤄 입력 차단 후 알림 //
      setTimeout(() => alert(t('myStoreSetting.centerInfo.centerIntroMaxLengthAlert')), 0);
      return;
    }

    setValue(e.target.value);
    setVal(e.target.value);
    setChanged(true);
  }

  function onFocusInput() {
    setChangedPlaceholderColor(false);
  }

  function onBlurInput() {
    setClickCount(clickCount + 1);
  }

  return (
    <Input
      ref={inputRef}
      clickCount={clickCount}
      type={type}
      placeholder={defaultPlaceholder}
      value={value}
      changedColor={changedPlaceholderColor}
      className={`${className} ${changed ? "changed" : ""}`}
      onChange={onChangeInput}
      onFocus={onFocusInput}
      onBlur={onBlurInput} />
  )
});

export default CenterIntroTextArea;

const Input = styled.textarea`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
  height: 146px;
  box-sizing: border-box;

  padding: 10px 15px;
  resize: none;
  overflow-y: auto;

  font-family: NotoSansKR-Medium;
  font-size: 14px;
  line-height: 1.4;

  color: ${props => props.theme.text};
  border: 1px dashed ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};

  outline: none;

  ::placeholder {
    color: ${props => props.changedColor ? props.theme.pointRed : props.theme.line};
  }

  &::-webkit-scrollbar {
    width: 9px;
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.primary};
    border: 3px solid transparent;
    border-radius: 200px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;
